import { Controller } from "@hotwired/stimulus";

declare var $: any;

export default class extends Controller {
  static targets = ["select"];
  static values = { placeholder: String };

  declare selectTarget: HTMLSelectElement;
  declare placeholderValue: string;

  connect() {
    // Defensive check: ensure multipleSelect plugin is loaded
    if (typeof $ !== 'undefined' && typeof $.fn.multipleSelect === 'function') {
      $(this.selectTarget).multipleSelect({
        allSelected: true,
        selectAll: true,
        formatAllSelected: () => 'All',
        formatSelectAll: () => 'Select All / None',
        maxHeight: '600',
        placeholder: this.placeholderValue || 'Select',
        width: '100%'
      });
    } else {
      console.warn('[MultipleSelectComponent] multipleSelect plugin not loaded.');
      // Fallback: component degrades gracefully to native multi-select
    }
  }
}
